var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "#F5F5F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1249 24.884C15.1249 25.514 15.6109 26 16.2409 26H20.9569C23.7649 26 25.6189 24.794 25.6189 22.544V22.508C25.6189 20.798 24.5929 19.952 23.1169 19.448C24.0529 18.962 24.9169 18.152 24.9169 16.64V16.604C24.9169 15.758 24.6289 15.074 24.0709 14.516C23.3509 13.796 22.2169 13.4 20.7769 13.4H16.2409C15.6109 13.4 15.1249 13.886 15.1249 14.516V24.884ZM17.3029 18.71V15.362H20.4889C21.9109 15.362 22.7029 15.974 22.7029 16.964V17C22.7029 18.152 21.7489 18.71 20.3269 18.71H17.3029ZM17.3029 24.038V20.582H20.8129C22.5589 20.582 23.4049 21.212 23.4049 22.274V22.31C23.4049 23.444 22.4869 24.038 20.9749 24.038H17.3029Z",
  fill: "#171A20"
});

var SvgBIcon = function SvgBIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/b-icon.10af8954.svg";
export { ForwardRef as ReactComponent };